// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

const checkStringMatch = (originalString, checkString) => {
  if (!originalString) return false
  return checkString.startsWith(originalString)
}

const jobHit = (item, classes = 'g-col-12 g-col-md-6') => {
  const {
    date,
    url,
    title,
    city,
    images,
    jobTypeContract,
  } = item

  return `
    <article class="feed-job ${classes}${
      images.full ? ' has-post-thumbnail' : ''
    }">
        <a href="${url}" class="feed-job__wrapper" ${images.full ? 'style="--bg : url(' + images.full + ');"' : ''}>       
            <div class="feed-job__top">
                <div class="feed-job__date">
                    ${__(
                      'Published the ',
                      'vn'
                    )}             
                    ${
                    date
                 }</div>      
                <div class="feed-job__title">${
                  title
                 }
                </div>
            </div>
            ${
              jobTypeContract.length
                ? `
            <div class="feed-job__bottom">
            
                <div class="feed-job__city"><i class="vn-icons-location_plus"></i>${
                  city
                }</div>
                
                <div class="feed-job__types">
                  ${jobTypeContract.map((jobContract) => {
                          return `<div>${jobContract.name}</div>`;
                      }).join('')}
                </div>
            </div>
            `
                : ''
            }
             
        </a>
    </article>
  `
}

export { jobHit }
